import { render, staticRenderFns } from "./TasksReport.vue?vue&type=template&id=54b2d4a8"
import script from "./TasksReport.vue?vue&type=script&lang=js"
export * from "./TasksReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports